<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">
                    <b-col lg="5" sm="12" class="text-left">
                        <lg-finder-page-unidade-administrativa id="finderUnidadeAdministrativa"
                            @onselect="handleSelectUnidadeAdministrativa" v-model="form.departamento"
                            invalidFeedback="Informe uma unidade administrativa!"
                            :podeMudarDepartamento="temPrivilegioGerenciarPatrimonio()"
                            :podeApagarDepartamento="temPrivilegioGerenciarPatrimonio()">
                        </lg-finder-page-unidade-administrativa>
                    </b-col>

                    <b-col cols="5" class="text-left">
                        <lg-finder-page-item-bem-permanente :prefix="[prefix, title]" :label="'Item:'"
                            :disabled="item != null"
                            v-model="form.item" id="finderItem" @onselect="handleItemBemPermanenteSelect"
                            invalidFeedback="">
                        </lg-finder-page-item-bem-permanente>

                    </b-col>


                    <b-col class="d-flex justify-content-end align-items-end">
                        <b-button id="rHL" class="ml-3 mr-2 my-2" size="sm" style="height: 40px" pill variant="primary"
                            @click="mostrarModal">
                            <b-icon icon="journal" />
                            <b-tooltip target="rHL" title="Relatório de Histórico de Lotação"></b-tooltip>
                        </b-button>

                    </b-col>


                    <b-col lg="6" sm="12" class="text-left">
                        <div class="" style="margin-left: 16px">
                            <lg-finder-page-produto :prefix="prefix + title + ' > '" id="finderProduto"
                                @onselect="handleProdutoSelect" v-model="form.produto"
                                invalidFeedback="Produto deve ser informada!" description="">
                            </lg-finder-page-produto>
                        </div>

                    </b-col>

                    <b-col lg="2" sm="12" class="text-left">
                        <lg-form-const-select label="Situação:" v-model="form.situacao"
                            :options="form.optionsFilterSituacao" />
                    </b-col>

                    <b-col cols="4" class="text-right mt-2">

                        <b-button id="limpar" class="my-2" size="sm" style="height: 20px" pill variant="primary"
                            @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="limpar" title="Limpar"></b-tooltip>
                        </b-button>

                        <b-button id="localizar" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="load">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="localizar" title="Localizar"></b-tooltip>
                        </b-button>
                    </b-col>
                </b-form-row>




            </b-card>

            <b-card bg-variant="light">
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" show-empty>


                    <template v-slot:cell(relatorio)="row">
                        <div :id="'relatorioPdf-' + row.item.id">
                            <img @click="gerarRelatorio(row.item.id)" :src="pdf" class="img img--clickable" alt="PDF" />
                            <b-tooltip :target="'relatorioPdf-' + row.item.id"
                                title="Relatório Movimentação de Bem Patrimonial..."></b-tooltip>

                        </div>
                    </template>


                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>



                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                    <template v-slot:cell(itemBemPermanente)="row">
                        <b-button :id="row.index + 'bloquear-button'" class="my-2" size="sm" pill variant="primary"
                            v-if="row.item.itemBemPermanente.bloqueado == 1">
                            <b-icon icon="lock" />
                            <b-tooltip :target="row.index + 'bloquear-button'" title="Item bloqueado"></b-tooltip>
                        </b-button>
                    </template>



                </b-table>
                <b-row style="margin-top: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>

        <b-modal size="md" button-size="sm" v-model="showModal"
            :title="prefix + title + ' > Relatório de Histórico de Lotação '" hide-footer @hidden="fecharModal">

            <b-row>
                <lg-form-date sm="6" invalidFeedback=" " description="" v-model="dataInicial" label="Data Inicial:" />
                <lg-form-date sm="6" invalidFeedback=" " description="" v-model="dataFinal" label="Data Final:" />

            </b-row>

            <div class="d-flex justify-content-center mt-3">

                <div :id="'relatorioHistoricoLotacaoPdf'">
                    <img @click="gerarRelatorioHL('PDF')" :src="pdf" class="img img--clickable" alt="PDF" />
                    <b-tooltip :target="'relatorioHistoricoLotacaoPdf'"
                        title="Emitir relatório no formato pdf"></b-tooltip>

                </div>

                <div :id="'relatorioHistoricoLotacaoXLS'">
                    <img @click="gerarRelatorioHL('EXCEL')" :src="xls" class="img img--clickable" alt="PDF" />
                    <b-tooltip :target="'relatorioHistoricoLotacaoXLS'"
                        title="Emitir relatório no formato xls"></b-tooltip>

                </div>

            </div>


        </b-modal>
    </b-card>
</template>

<script>
import XlsIcon from "@/core/assets/icons/xls.png"

import LgFormDate from "@/core/components/Form/LgFormDate.vue"

import DownloadArquivoService from "@/core/utils/DownloadArquivoUtil";
import PdfIcon from "@/core/assets/icons/pdf.png";
import LgFinderPageItemBemPermanente from "@/components//Finders/LgFinderPageItemBemPermanente.vue";
import LgFinderPageProduto from "@/components/Finders/LgFinderPageProduto.vue";
import ResourceService from "@/core/api/ResourceService";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import moment from "moment";
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"

export default {
    components: {
        LgFinderPageProduto,
        LgFinderPageUnidadeAdministrativa,
        LgFormConstSelect,
        LgFinderPageItemBemPermanente,
        LgFormDate
    },

    created() {
        const brand = JSON.parse(localStorage.getItem("context"));
        this.form.departamento = brand.departamento;
        this.form.departamento.descricao = this.form.departamento.nome
        this.form.pessoa = brand.usuario;
    },
    props: {
        prefix: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Histórico de Lotação"
        },
        item: {
            type: Object,
            default: () => null
        },
    },

    data() {
        return {
            dataInicial: "",
            dataFinal: "",
            showModal: false,
            pdf: PdfIcon,
            xls: XlsIcon,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            form: {
                id: "",
                dataInicial: "",
                dataFinal: "",
                item: {},
                departamento: {},
                produto: {},
                situacao: 1,
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: undefined },
                    { key: "filterSituacao", text: "Ativo", value: 1 },
                    { key: "filterSituacao", text: "Inativo", value: 0 },
                ],
            },
        };
    },

    mixins: [ListResourceMixin],
    async beforeMount() {
        this.$service = new ResourceService(`/api/historicolocacao`);
        this.$statusService = new ResourceService(`/api/status/tipo/54`);

        if(this.item && this.item.id)
        this.form.item = {id: this.item.id, descricaoResumida: this.item.itemRegEntrada.produto.descricaoResumida};
    },
    async mounted() {
        this.$service = new ResourceService(`/api/historicolocacao`);

        this.load();
    },

    watch: {
        page() {
            this.load();
        },
    },
    computed: {
        tableFields() {
            return [
                {
                    key: "itemBemPermanente",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 600;",
                    tdStyle: "font-size: 13px",
                },

                {
                    key: "itemBemPermanente.numTombamento",
                    label: "TOMBAMENTO",
                    thStyle: "font-size: 16px; font-weight: 600;",
                    tdStyle: "font-size: 13px",
                    tdClass: "text-center",
                    thClass: "text-center",
                },

                {
                    key: "departamento.descricao",
                    label: "UNID. ADMINISTRATIVA ATUAL",
                    thStyle: "font-size: 16px; font-weight: 600;",
                    tdStyle: "font-size: 13px",
                    tdClass: "text-center",
                    thClass: "text-center",
                },

                {
                    key: "itemBemPermanente.itemRegEntrada.produto.numero",
                    label: "NÚMERO",
                    thStyle: "font-size: 16px; font-weight: 600;",
                    tdStyle: "font-size: 13px",
                    tdClass: "text-center",
                    thClass: "text-center",
                },

                {
                    key: "itemBemPermanente.itemRegEntrada.produto.descricaoResumida",
                    label: "ITEM",
                    thStyle: "font-size: 16px; font-weight: 600;",
                    tdStyle: "font-size: 13px",
                    tdClass: "text-center",
                    thClass: "text-center",
                },

                {
                    key: "dataInicial",
                    label: "DATA INICIAL",
                    formatter: (value) => moment(value).format("DD/MM/YYYY"),
                    thStyle: "font-size: 16px; font-weight: 600;",
                    tdStyle: "font-size: 13px",
                    tdClass: "text-center",
                    thClass: "text-center",
                },

                {
                    key: "dataFinal",
                    label: "DATA FINAL",
                    formatter: (value) => value ? moment(value).format("DD/MM/YYYY") : "",
                    thStyle: "font-size: 16px; font-weight: 600;",
                    tdStyle: "font-size: 13px",
                    tdClass: "text-center",
                    thClass: "text-center",
                },

                {
                    key: "pessoa.nome",
                    label: "RESP. MOVIMENTAÇÃO",
                    thStyle: "font-size: 16px; font-weight: 600;",
                    tdStyle: "font-size: 13px",
                    tdClass: "text-center",
                    thClass: "text-center",
                },

                {
                    key: "departamentoOrigem.descricao",
                    label: "UNID. ADMINISTRATIVA ANTERIOR",
                    thStyle: "font-size: 16px; font-weight: 600;",
                    tdStyle: "font-size: 13px",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "relatorio",
                    label: " ",
                },

            ];
        },
    },
    methods: {
        async gerarRelatorioHL(formato) {

            if (this.dataInicial == "" || this.dataFinal == "") {
                this.$notify({
                    type: "danger",
                    message: 'É necessário selecionar um período',
                });

                return;

            }

            this.param = {};
            this.param.dataInicial = this.dataInicial;
            this.param.dataFinal = this.dataFinal;
            this.param.departamento = this.form.departamento.id;

            this.busy = true
            try {
                const resource = new ResourceService('/api/relatorio/gerar-relatorio-historico-lotacao');
                const { data } = await resource.getWithParams(formato, this.param);
                DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            } finally {
                this.busy = false;
            }


        },

        mostrarModal() {
            this.showModal = true;
        },
        fecharModal() {
            this.showModal = false;
        },
        async gerarRelatorio(id) {
            this.param = {};
            this.param.id = id

            this.busy = true
            try {
                const resource = new ResourceService('/api/relatorio/gerar-relatorio-movimentacao-ibp');
                const { data } = await resource.getWithParams('PDF', this.param);
                DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            } finally {
                this.busy = false;
            }


        },



        temPrivilegioGerenciarPatrimonio() {
            return verificaPrivilegio(PrivilegiosEnum.GERENCIAR_PATRIMONIO);

        },

        async load() {
            this.filtro = {};

            if (this.item && this.item.id) {
                this.filtro.itemId = this.item.id;
            }
            else
                if (this.form.item && this.form.item.id) {
                    this.filtro.itemId = this.form.item.id;
                }


            if (this.form.departamento && this.form.departamento.id) {
                this.filtro.departamentoId = this.form.departamento.id;
            }

            if (this.form.produto && this.form.produto.id) {
                this.filtro.produtoId = this.form.produto.id;
            }

            if (this.form.situacao) {
                this.filtro.situacao = this.form.situacao;
            }
            this.busy = true
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,
            });
        },

        clearForm() {
            this.form.item = {};
            this.form.produto = {};
            this.load();
        },



        handleSelectUnidadeAdministrativa(departamento) {
            this.form.departamento = departamento;
            this.load();

        },


        async handleProdutoSelect(item) {
            this.$set(this.form, "produto", item);
            this.load();
        },


        async handleItemBemPermanenteSelect(item) {


            this.form.item = item;
            this.load();

        },

    },
};
</script>
